import React from "react";
import { Spinner } from "react-bootstrap";

export default function Loading() {
  return (
    <div
      className="container d-flex flex-row justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="row">
        <div className="col text-center">
          <Spinner animation="grow" />
          <p>Loading...</p>
        </div>
      </div>
    </div>
  );
}
